import apiClient from "../../axios/apiClient"


export const login = (data) => async (dispatch) => {
    try {
        dispatch({ type: "LOGIN_PENDING" })
        const response = await apiClient.post("api/v1/auth/login", data)
        localStorage.setItem("asg_phedr_admin", JSON.stringify(response.data))
        dispatch({ type: "LOGIN_FULFILLED", payload: response.data })

    } catch (error) {
        dispatch({ type: "LOGIN_FAILED", payload: error.response })
    }
}

export const refreshToken = (refreshToken) => async (dispatch) => {
    try {
        dispatch({ type: "REFRESH_TOKEN_PENDING" })
        const response = await apiClient.post("api/v1/auth/refresh", { refreshToken })
        const authData = localStorage.getItem("asg_phedr_admin")
        const currentAuth = authData ? JSON.parse(authData) : {}
        const updatedAuth = {
            ...currentAuth,
            accessToken: response.data.accessToken,
            refreshToken: response.data.refreshToken || refreshToken
        }
        localStorage.setItem("asg_phedr_admin", JSON.stringify(updatedAuth))
        dispatch({ type: "REFRESH_TOKEN_FULFILLED", payload: updatedAuth })
        return updatedAuth
    } catch (error) {
        dispatch({ type: "REFRESH_TOKEN_FAILED", payload: error.response })
        localStorage.removeItem("asg_phedr_admin")
        dispatch({ type: "LOG_OUT_FULFILLED" })
        throw error
    }
}

export const logout = () => async (dispatch) => {
    localStorage.removeItem("asg_phedr_admin")
    dispatch({ type: "LOG_OUT_FULFILLED" })
}

